import React from "react";

const TextInput = ({
  label,
  name,
  value,
  onChange,
  required = false,
  type = "text",
}) => {
  return (
    <div className="mb-2">
      <label className="block text-gray-700">{label}</label>
      <input
        type={type}
        required={required}
        name={name}
        value={value}
        onChange={onChange}
        className="w-full border px-4 py-2 rounded"
        autoComplete="off"
      />
    </div>
  );
};

export default TextInput;
